import { render } from "./InternEvaluationDialog.vue?vue&type=template&id=2bfa9590&scoped=true"
import script from "./InternEvaluationDialog.vue?vue&type=script&lang=js"
export * from "./InternEvaluationDialog.vue?vue&type=script&lang=js"

import "./InternEvaluationDialog.vue?vue&type=style&index=0&id=2bfa9590&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bfa9590"]])

export default __exports__